/**
 * useSubscription Hook - Now uses global SubscriptionContext
 * This prevents multiple API calls by sharing subscription data across all components
 */

import { useSubscriptionContext } from '../../contexts/SubscriptionContext';

export function useSubscription() {
  return useSubscriptionContext();
}